import { VENDOR_ADDRESSES_ACTIONS, initialVendorAddressesState } from './vendorAddresses.types'

/**
 * @param {import('./vendorAddresses.types').VendorAddressesSlice} state
 * @param {Object} action
 */
export function vendorAddressesReducer(state = initialVendorAddressesState, { type, payload }) {
  switch (type) {
    case VENDOR_ADDRESSES_ACTIONS.SET_VENDOR_ADDRESSES:
      return { ...state, data: payload }

    case VENDOR_ADDRESSES_ACTIONS.SET_VENDOR_ADDRESS:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case VENDOR_ADDRESSES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case VENDOR_ADDRESSES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case VENDOR_ADDRESSES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
